var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "story-maker-sticker-menu-product" }, [
    !_vm.shopSelected
      ? _c("div", { staticClass: "section-shop" }, [
          _c("div", { staticClass: "header-menu" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.$t("dash.post-creator.story.shop-title"))),
            ]),
          ]),
          _c("div", { staticClass: "search-bar" }, [
            _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.models.searchShop,
                  expression: "models.searchShop",
                },
              ],
              attrs: {
                placeholder: _vm.$t("dash.post-creator.overlay.search"),
              },
              domProps: { value: _vm.models.searchShop },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.models, "searchShop", $event.target.value)
                },
              },
            }),
          ]),
          _c(
            "div",
            { staticClass: "container-shop hide-scrollbar" },
            [
              _vm.loading.shop
                ? _c("span", { staticClass: "loader" })
                : [
                    !_vm.models.searchShop.length
                      ? _c("p", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "dash.post-creator.overlay.suggested-shops"
                              )
                            )
                          ),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "list list-shop hide-scrollbar" },
                      _vm._l(
                        _vm.models.searchShop.length
                          ? _vm.shops
                          : _vm.dataInstagramDefault.shops,
                        function (shop, index) {
                          return _c(
                            "div",
                            {
                              key: shop.id,
                              staticClass: "item",
                              on: {
                                click: function ($event) {
                                  return _vm.selectShop(shop)
                                },
                              },
                            },
                            [
                              _c("img", { attrs: { src: shop.image } }),
                              _c("p", { staticClass: "shop-title" }, [
                                _vm._v(_vm._s(shop.text)),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ],
            ],
            2
          ),
        ])
      : _c("div", { staticClass: "section-product" }, [
          _c("div", { staticClass: "header-menu" }, [
            _c("div", {
              staticClass: "return",
              on: { click: _vm.closeProductList },
            }),
            _c("p", [_vm._v(_vm._s(_vm.shopSelected.text))]),
          ]),
          _c("div", { staticClass: "search-bar" }, [
            _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.models.searchProduct,
                  expression: "models.searchProduct",
                },
              ],
              attrs: {
                placeholder: _vm.$t("dash.post-creator.overlay.search"),
              },
              domProps: { value: _vm.models.searchProduct },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.models, "searchProduct", $event.target.value)
                },
              },
            }),
          ]),
          _c("div", { staticClass: "container-product" }, [
            !_vm.models.searchProduct.length
              ? _c("p", { staticClass: "title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("dash.post-creator.overlay.suggested-products")
                    )
                  ),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "list list-product hide-scrollbar" },
              [
                _vm.loading.product
                  ? _c("span", { staticClass: "loader" })
                  : _vm._l(
                      _vm.models.searchProduct.length
                        ? _vm.products
                        : _vm.defaultProducts,
                      function (product, index) {
                        return _c(
                          "div",
                          {
                            key: product.id,
                            staticClass: "item",
                            class: {
                              active: _vm.productsSelected.some(
                                (p) => p.id == product.id
                              ),
                              disable: _vm.productsSelected.length == 5,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.selectProduct(product)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "image" }, [
                              _c("img", { attrs: { src: product.image } }),
                            ]),
                            _c("div", { staticClass: "info" }, [
                              _c("p", { staticClass: "product-name" }, [
                                _vm._v(_vm._s(product.text)),
                              ]),
                              _c("p", { staticClass: "product-price" }, [
                                _vm._v(_vm._s(product.description)),
                              ]),
                            ]),
                            _c("div", { staticClass: "check" }),
                          ]
                        )
                      }
                    ),
              ],
              2
            ),
          ]),
          _vm.productSelected
            ? _c("div", { staticClass: "container-select-variant" }, [
                _c("div", { staticClass: "select-variant" }, [
                  _c("h5", [
                    _vm._v(
                      _vm._s(_vm.$t("dash.post-creator.overlay.variant-choice"))
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "list-item-variant hide-scrollbar" },
                    [
                      _vm.loading.productVariant
                        ? _c("span", { staticClass: "loader" })
                        : _vm._l(
                            _vm.variantsProducts,
                            function (product, index) {
                              return _c(
                                "div",
                                {
                                  staticClass: "item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectVariant(product)
                                    },
                                  },
                                },
                                [
                                  _c("img", { attrs: { src: product.image } }),
                                  _c("p", { staticClass: "product-name" }, [
                                    _vm._v(_vm._s(product.number)),
                                  ]),
                                ]
                              )
                            }
                          ),
                    ],
                    2
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
    _vm.productsSelected.length
      ? _c("div", { staticClass: "button", on: { click: _vm.finish } }, [
          _vm._v(
            _vm._s(
              _vm.$t("dash.post-creator.story.validate-count", {
                count: _vm.productsSelected.length,
              })
            )
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }